module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vlymp12-3f20a059b9bb4fe7c62c1988b4b24c94.jpg";